
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"#5EA9FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.001 6.406a6.07 6.07 0 00-4.542 2.057l1.392 1.3a4.19 4.19 0 016.3 0l1.392-1.3a6.07 6.07 0 00-4.542-2.057z"}}),_c('path',{attrs:{"d":"M6 10.83l2 1.863 2-1.864a2.658 2.658 0 00-4 0zM8 3a9.35 9.35 0 00-7 3.172l1.392 1.3a7.458 7.458 0 0111.216 0L15 6.172A9.351 9.351 0 008 3z"}})])
          )
        }
      }
    